<section fxLayout="column" fxFlexAlign="stretch"> 
    <table>
        <tr>
           <td style="vertical-align: top;width: 30%;">
               <img src="../../assets/afisa3.jpg" width="100%" />
           </td> 
           <td style="vertical-align: top;padding-left: 12px;">
               <div>
                   
                   <h2>Χαιρετισμός Προέδρου</h2>
                   <br/>
                   <p>H Εταιρεία Μελέτης και Έρευνας της Καρδιακής Ανεπάρκειας οργανώνει το 24ο Πανελλήνιο
                    Συνέδριο Καρδιακής Ανεπάρκειας στις 3-5 Φεβρουαρίου 2023. Στο Συνέδριο θα παρουσιασθούν οι
                    σημαντικότερες εξελίξεις στην καρδιακή ανεπάρκεια.</p>
                   <p>Τα τελευταία χρόνια o κλινικός καρδιολόγος χρειάζεται να γνωρίζει σε βάθος ό,τι αφορά όχι μόνο
                    στη διάγνωση και τη θεραπεία του συνδρόμου, αλλά και στις αρρυθμίες, την ανοσολογία, την εντατική
                    θεραπεία, την απεικόνιση και τις συσκευές, θέματα που θα καλυφθούν στο Συνέδριο.</p>
                   <p>Στο συνέδριο θα καλυφθούν τα θέματα που απασχολούν κάθε λειτουργό υγείας που αντιμετωπίζει
                    ασθενείς με καρδιακή ανεπάρκεια, συμπεριλαμβανομένων των καθιερωμένων θεραπευτικών
                    προσεγγίσεων και των νεότερων ερευνητικών και κλινικών δεδομένων. Παράλληλα, θα καταδειχθεί
                    η σπουδαιότητα της λειτουργίας ιατρείων καρδιακής ανεπάρκειας και καρδιoγκολογίας, του
                    ευεργετικού ρόλου των προγραμμάτων σωματικής άσκησης με την εξαιρετική συνεργασία της
                    ΕΛΕΡΓΑ (Ελληνική Εταιρεία Εργοσπιρομετρίας Άσκησης και Αποκατάστασης) και η πολυδιάστατη
                    βοήθεια που προσφέρουν οι νοσηλευτές στο ευρύ φάσμα θεραπειών που εφαρμόζονται στους
                    ασθενείς με καρδιακή ανεπάρκεια.</p>
                   <p>Η ΕΜΕΚΑ έχει διαχρονική συνεργασία με την Ευρωπαϊκή Εταιρεία Καρδιακής Ανεπάρκειας (HFA), και
                    τη Διεθνή Εταιρεία Καρδιογκολογίας (ICOS), η οποία εκφράζεται στο συνέδριο με ειδικές συνεδρίες
                    μετεκπαίδευσης στην προχωρημένη καρδιακή ανεπάρκεια και στην καρδιογκολογία.</p>
                   <p>Στα πλαίσια του Συνεδρίου -την παραμονή- θα γίνει και η καθιερωμένη συνάντηση του Εθνικού
                    Δικτύου Ιατρείων Καρδιακής Ανεπάρκειας και του Εθνικού Δικτύου Ιατρείων Καρδιο-ογκολογίας,
                    όπου θα καλυφθεί ένα ευρύ πεδίο θεμάτων.</p>
                   <p>Μετά από 26 έτη επιτυχημένης πορείας της ΕΜΕΚΑ, το συνέδριό παρέχει εξειδικευμένη γνώση στους
                    συμμετέχοντες και είναι πεδίο για έναν ευρύτερο επιστημονικό και κοινωνικό διάλογο με επίκεντρο
                    την καρδιακή ανεπάρκεια</p>
                    <p>Αυτό που έχει χαθεί τα τελευταία χρόνια στις επιστημονικές συναντήσεις, λόγω της πανδημίας, είναι
                        η αλληλεπίδραση. Το φετινό Συνέδριο θα προσπαθήσει να επαναφέρει την επικοινωνία μεταξύ των
                        ειδικών αλλά και όλων των επαγγελματιών στο χώρο της υγείας.</p>
                    <p>Καλούμε όλους τους επαγγελματίες υγείας που αντιμετωπίζουν καθημερινά ασθενείς με καρδιακή
                        ανεπάρκεια, να αγκαλιάσουν την προσπάθεια και να συμμετάσχουν ενεργά στις εργασίες του συνεδρίου
                        με τρόπο διαδραστικό, εμπλουτίζοντας και ανανεώνοντας τις γνώσεις τους, ανταλλάσσοντας απόψεις,
                        και τελικά, συμμετέχοντας στη διαμόρφωση του τοπίου της καρδιακής ανεπάρκειας στη χώρα μας.</p>
                        
                    <br/>
                    <p><b>Kαθ. Γεράσιμος Φιλιππάτος</b></p>
                    <p><b>Πρόεδρος της ΕΜΕΚΑ</b></p>
                    <br/>
                    <br/>
                    <p style="color:#1261aa"><b>*Η παρακολούθηση επιτρέπεται μόνο σε επιστήμονες υγείας</b>  </p>
                   <!-- <div><img src="..\..\assets\images\terzidou.jpg" /></div> -->
               </div>
           </td>
        </tr>
    </table>
    </section>